export const consequenceSeverityTable = [
	{
		consequence: "Personal Injury and health effects",
		severity_list: {
			E: "Fatality/-ies",
			D: "Serious injury/possibility for permanent disability",
			C: "Serious injury/requiring sickness leave (LTI)",
			B: "Medical treatment injury (MTI)",
			A: "First Aid Injury (FAI)",
		},
	},
	{
		consequence: "Well Control",
		severity_list: {
			E: "Primary and secondary barriers failed. Blowout to environment or facility, including underground blowout. Requires relief well drilling, capping or handled on installation.",
			D: "Primary and barier fails, uncertain secondary barrier. High HC influx, critical kill operations with high risk of blowout.",
			C: "Loss of primary barrier, second unaffected. Medium HC influx volume, kick tolerance that can be handled with kill procedures.",
			B: "Uncertain primary well barrier status, second unaffected. Low HC or water influx. Volume less than kick tolerance -> handled with well control procedure.",
			A: "One barrier weakened & second unaffected.",
		},
	},
	{
		consequence: "Discharge to the environment (HC)",
		severity_list: {
			E: ">500 m³",
			D: "50-500 m³",
			C: "0.1-50 m³",
			B: "0,01-0.1 m³",
			A: "<0,1 m³",
		},
	},
	{
		consequence: "Discharge to the environment (Chemicals)",
		severity_list: {
			E: "Black/Red (>100 m³)",
			D: "Black/Red (1-100 m³)",
			C: "Black/Red (0.01-1 m³) or Yellow/Green (>10 m³)",
			B: "Black/Red (<0.01 m³) or Yellow/Green (<=10 m³)",
			A: "<0.01 m³",
		},
	},
	{
		consequence: "Discharge to the environment (Contained)",
		severity_list: {
			E: ">500 m³",
			D: "50-500 m³",
			C: "0.1-50 m³",
			B: "0,01-0.1 m³",
			A: "<0,1 m³",
		},
	},
	{
		consequence: "Asset Damage (damage to equipment and NPT)",
		severity_list: {
			E: ">100MNOK",
			D: "30-100MNOK",
			C: "10-30MNOK",
			B: "5-10MNOK",
			A: "<5MNOK",
		},
	},
	{
		consequence: "Reputation",
		severity_list: {
			E: "Major adverse national media/public attention",
			D: "Significant impact on business reputation and or media exposure",
			C: "Serious adverse local public or media attention or compliant",
			B: "Minor impact. Public awareness, but no public concern",
			A: "Negligible impact on reputation",
		},
	},
];

export const risk_frequency = {
	1: "0 to 14 days",
	2: "14 days to 6 months",
	3: "6 months to 1 year",
	4: "1-5 years",
	5: "Less frequent than 5 years",
};

export const probability_score = {
	HIGH: ["E1", "E2", "E3", "E4", "E5", "D3", "D4", "D5"],
	MEDIUM: ["D1", "D2", "C2", "C3", "C4", "C5", "B4", "B5"],
	LOW: ["C1", "B1", "B2", "B3", "A1", "A2", "A3", "A4", "A5"],
};
